const { signal } = require("@preact/signals");

export const myGrpsSignal = signal(null);